import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  noContent: {
    height: '710px',
  },
  surveys: {
    display: 'table-cell',
    textAlign: 'center',
    padding: '50px',
    '& svg': {
      width: '40px',
      height: '40px',
      color: theme.palette.primary.main,
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontWeight: '600',
    },
  },
  checkbox: {
    '& .Mui-checked': {
      color: theme.palette.secondary.blue,
      opacity: 0.5,
    },
  },
  id: {
    fontWeight: 'bold',
    width: '3%',
    color: theme.palette.primary.mainBlue,
  },
  tooltipWidget: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    borderRadius: '20px',
    backgroundColor: theme.palette.custom.tooltipBackground,
    padding: '10px',
  },
  tooltipNumber: {
    color: theme.palette.custom.tooltipText,
    fontSize: '15px',
  },
  tooltipBar: {
    textDecoration: 'none',
    color: theme.palette.custom.tooltipText,
    fontSize: '15px',
  },
  tooltipText: {
    color: theme.palette.custom.tooltipText,
    fontSize: '15px',
  },
  iconsCell: {
    '& svg': {
      color: theme.palette.primary.gray,
      cursor: 'pointer',
      '&:hover': {
        color: theme.palette.secondary.blue,
      },
    },
    '&:hover': {
      '& button': {
        backgroundColor: 'transparent',
      },
    },
    fontSize: '10px',
  },
  tableHeader: {
    color: theme.palette.secondary.gray,
    '& .Mui-checked': {
      color: theme.palette.secondary.blue,
      opacity: 0.5,
    },
    '& .MuiCheckbox-indeterminate ': {
      color: theme.palette.secondary.blue,
      opacity: 0.5,
    },
  },
  progress: {
    height: '610px',
    display: 'table-cell',
    textAlign: 'center',
    padding: '50px',
    '& div': {
      color: theme.palette.primary.main,
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontWeight: '200',
    },
  },
}));

export default useStyles;
